import EcoSectionCard from 'eco-design/sections/eco-section-card';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Comp() {
    const { t } = useLang('dp3.page_v2.SectionC');

    const configs = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745465002184/SectionC%20pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1745465002028/SectionC%20h5.jpg',
        title: t('title'),
    };

    return (
        <div className={styles.comp} id="SectionC">
            <EcoSectionCard theme="black" layout="center-center" {...configs} />
        </div>
    );
}
